import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=db708be4&scoped=true"
import script from "./UserChip.vue?vue&type=script&lang=js"
export * from "./UserChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db708be4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db708be4')) {
      api.createRecord('db708be4', component.options)
    } else {
      api.reload('db708be4', component.options)
    }
    module.hot.accept("./UserChip.vue?vue&type=template&id=db708be4&scoped=true", function () {
      api.rerender('db708be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/UserChip.vue"
export default component.exports